export default function PopularCategories() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-semibold mb-3">
            Popularne
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Popularne Kategorie Kakobuy
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Odkryj najczęściej wyszukiwane kategorie produktów na Kakobuy Spreadsheet.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          <a
            href="https://kaspreadsheet.com/category-911-Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative overflow-hidden rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all cursor-pointer"
          >
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Stylish%20pair%20of%20contemporary%20casual%20sneakers%20with%20chunky%20sole%20design%20in%20warm%20oatmeal%20and%20sage%20green%20colors%2C%20placed%20on%20a%20textured%20cream%20linen%20surface%2C%20soft%20diffused%20morning%20light%20from%20left%20side%20creating%20gentle%20shadows%2C%20editorial%20product%20photography%20with%20minimalist%20scandinavian%20aesthetic%2C%20clean%20background%20with%20subtle%20natural%20fabric%20textures%2C%20warm%20inviting%20atmosphere&width=800&height=600&seq=pop-sneakers-v2-01&orientation=landscape"
                alt="Sneakers - Kakobuy Spreadsheet"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5">
              <div className="flex items-center gap-2 mb-1.5">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100/70 text-primary-600 text-sm"><i className="ri-footprint-line"></i></span>
                <h3 className="font-heading text-base font-semibold text-foreground-900">Sneakers</h3>
              </div>
              <p className="text-foreground-600 text-xs leading-relaxed">Najlepsze kicks od Nike, Jordan, Adidas</p>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-912/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative overflow-hidden rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all cursor-pointer"
          >
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Premium%20oversized%20terracotta%20colored%20hoodie%20neatly%20folded%20on%20a%20warm%20cream%20wool%20blanket%2C%20soft%20golden%20hour%20light%20streaming%20through%20linen%20curtains%20casting%20delicate%20shadows%2C%20modern%20minimalist%20fashion%20photography%2C%20rich%20organic%20textures%20with%20subtle%20fabric%20grain%20details%2C%20warm%20amber%20and%20earth%20tone%20color%20palette%2C%20serene%20scandinavian%20interior%20atmosphere&width=800&height=600&seq=pop-hoodies-v2-02&orientation=landscape"
                alt="Hoodies - Kakobuy Spreadsheet"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5">
              <div className="flex items-center gap-2 mb-1.5">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100/70 text-primary-600 text-sm"><i className="ri-t-shirt-line"></i></span>
                <h3 className="font-heading text-base font-semibold text-foreground-900">Hoodies</h3>
              </div>
              <p className="text-foreground-600 text-xs leading-relaxed">Bluzy i swetry streetwear</p>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-914/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative overflow-hidden rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all cursor-pointer"
          >
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20olive%20green%20bomber%20jacket%20hanging%20on%20a%20minimalist%20wooden%20hanger%20against%20a%20warm%20cream%20wall%2C%20soft%20natural%20daylight%20from%20a%20nearby%20window%20creating%20gentle%20highlights%20on%20the%20fabric%20texture%2C%20clean%20editorial%20fashion%20photography%2C%20premium%20material%20with%20subtle%20sheen%2C%20sophisticated%20contemporary%20aesthetic%20with%20warm%20earthy%20tones%2C%20peaceful%20and%20refined%20atmosphere&width=800&height=600&seq=pop-jackets-v2-03&orientation=landscape"
                alt="Jackets - Kakobuy Spreadsheet"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5">
              <div className="flex items-center gap-2 mb-1.5">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100/70 text-primary-600 text-sm"><i className="ri-shirt-line"></i></span>
                <h3 className="font-heading text-base font-semibold text-foreground-900">Jackets</h3>
              </div>
              <p className="text-foreground-600 text-xs leading-relaxed">Kurtki i płaszcze premium</p>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-921/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative overflow-hidden rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all cursor-pointer"
          >
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Stylish%20camel%20brown%20leather%20tote%20bag%20with%20clean%20architectural%20lines%20placed%20on%20a%20light%20cream%20marble%20surface%2C%20soft%20afternoon%20light%20creating%20gentle%20reflections%20and%20warm%20shadows%2C%20luxury%20minimalist%20product%20photography%2C%20rich%20cognac%20leather%20texture%20with%20subtle%20grain%20details%2C%20elegant%20contemporary%20design%2C%20sophisticated%20warm%20neutral%20palette%20with%20brass%20accent%20hardware&width=800&height=600&seq=pop-bags-v2-04&orientation=landscape"
                alt="Bags - Kakobuy Spreadsheet"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5">
              <div className="flex items-center gap-2 mb-1.5">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100/70 text-primary-600 text-sm"><i className="ri-shopping-bag-line"></i></span>
                <h3 className="font-heading text-base font-semibold text-foreground-900">Bags</h3>
              </div>
              <p className="text-foreground-600 text-xs leading-relaxed">Torby i plecaki w każdym stylu</p>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-920/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative overflow-hidden rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all cursor-pointer"
          >
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20arrangement%20of%20premium%20fashion%20accessories%20including%20a%20sleek%20minimalist%20watch%20with%20leather%20strap%20and%20designer%20sunglasses%20on%20a%20warm%20sand%20colored%20linen%20surface%2C%20soft%20natural%20window%20light%20with%20gentle%20diffusion%2C%20editorial%20still%20life%20photography%2C%20sophisticated%20warm%20amber%20and%20taupe%20color%20palette%2C%20refined%20contemporary%20aesthetic%20with%20organic%20textures%2C%20elegant%20and%20aspirational%20mood&width=800&height=600&seq=pop-accessories-v2-05&orientation=landscape"
                alt="Accessories - Kakobuy Spreadsheet"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5">
              <div className="flex items-center gap-2 mb-1.5">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100/70 text-primary-600 text-sm"><i className="ri-glasses-line"></i></span>
                <h3 className="font-heading text-base font-semibold text-foreground-900">Accessories</h3>
              </div>
              <p className="text-foreground-600 text-xs leading-relaxed">Okulary, biżuteria, zegarki</p>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-924/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative overflow-hidden rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all cursor-pointer"
          >
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20wireless%20earbuds%20in%20warm%20sand%20beige%20color%20resting%20on%20a%20textured%20cream%20ceramic%20dish%2C%20soft%20diffused%20daylight%20with%20gentle%20highlights%20on%20the%20matte%20surface%2C%20clean%20minimalist%20product%20photography%2C%20contemporary%20tech%20lifestyle%20aesthetic%2C%20warm%20neutral%20tones%20with%20subtle%20sage%20green%20plant%20accent%20in%20defocused%20background%2C%20serene%20and%20sophisticated%20atmosphere&width=800&height=600&seq=pop-electronics-v2-06&orientation=landscape"
                alt="Electronics - Kakobuy Spreadsheet"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5">
              <div className="flex items-center gap-2 mb-1.5">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100/70 text-primary-600 text-sm"><i className="ri-headphone-line"></i></span>
                <h3 className="font-heading text-base font-semibold text-foreground-900">Electronics</h3>
              </div>
              <p className="text-foreground-600 text-xs leading-relaxed">Gadżety i elektronika</p>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}